import { MANAGEMENT_OF_COMPANIES_SECTOR, SCIENTIFIC_SERVICES_SECTOR, UTILITIES_SECTOR } from './industrySectorOptions';
import {
  ACCOMMODATION_SUB_SECTOR,
  ADMINISTRATION_OF_ECONOMIC_PROGRAMS_SUB_SECTOR,
  ADMINISTRATION_OF_ENVIRONMENTAL_QUALITY_SUB_SECTOR,
  ADMINISTRATION_OF_HOUSING_PROGRAMS_SUB_SECTOR,
  ADMINISTRATION_OF_HUMAN_RESOURCE_SUB_SECTOR,
  ADMINISTRATIVE_SERVICE_SUB_SECTOR,
  AGENTS_AND_BROKERS_SUB_SECTOR,
  AGRICULTURE_SUPPORT_ACTIVITIES_SUB_SECTOR,
  AIR_TRANSPORTATION_SUB_SECTOR,
  AMBULATORY_CARE_SUB_SECTOR,
  AMUSEMENT_INDUSTRY_SUB_SECTOR,
  ANIMAL_AND_AGRICULTURE_SUB_SECTOR,
  APPAREL_MANUFACTURING_SUB_SECTOR,
  BEVERAGE_AND_TOBACCO_MANUFACTURING_SUB_SECTOR,
  BROADCASTING_PROVIDER_SUB_SECTOR,
  BUILDING_CONSTRUCTION_SUB_SECTOR,
  BUILDING_MATERIAL_DEALERS_SUB_SECTOR,
  CHEMICAL_MANUFACTURING_SUB_SECTOR,
  CLOTHING_RETAILERS_SUB_SECTOR,
  COMPUTER_AND_ELECTRONIC_MANUFACTURING_SUB_SECTOR,
  COMPUTING_INFRASTRUCTURE_SUB_SECTOR,
  COURIERS_SUB_SECTOR,
  CREDIT_INTERMEDIATION_SUB_SECTOR,
  CROP_PRODUCTION_SUB_SECTOR,
  DURABLE_GOODS_SUB_SECTOR,
  EDUCATIONAL_SERVICES_SUB_SECTOR,
  ELECTRICAL_EQUIPMENT_MANUFACTURING_SUB_SECTOR,
  EXECUTIVE_LEGISLATIVE_SUB_SECTOR,
  FABRICATED_METAL_MANUFACTURING_SUB_SECTOR,
  FISHING_HUNTING_TRAPPING_SUB_SECTOR,
  FOOD_MANUFACTURING_SUB_SECTOR,
  FOOD_RETAILERS_SUB_SECTOR,
  FOOD_SERVICES_AND_DRINKING_PLACES_SUB_SECTOR,
  FORESTRY_AND_LOGGING_SUB_SECTOR,
  FUNDS_TRUSTS_SUB_SECTOR,
  FURNITURE_MANUFACTURING_SUB_SECTOR,
  FURNITURE_RETAILERS_SUB_SECTOR,
  GASOLINE_DEALERS_SUB_SECTOR,
  HEALTH_RETAILERS_SUB_SECTOR,
  HEAVY_AND_CIVIL_ENGINEERING_CONSTRUCTION_SUB_SECTOR,
  HOSPITALS_SUB_SECTOR,
  INSURANCE_CARRIERS_SUB_SECTOR,
  JUSTICE_PUBLIC_ORDER_SUB_SECTOR,
  LAUNDRY_SERVICE_SUB_SECTOR,
  LEATHER_AND_ALLIED_PRODUCT_MANUFACTURING_SUB_SECTOR,
  LESSORS_OF_NONFINACIAL_ASSETS_SUB_SECTOR,
  MACHINERY_MANUFACTURING_SUB_SECTOR,
  MERCHANDISE_RETAILERS_SUB_SECTOR,
  MINING_SUB_SECTOR,
  MINING_SUPPORT_ACTIVITIES_SUB_SECTOR,
  MISCELLANEOUS_MANUFACTURING_SUB_SECTOR,
  MONETARY_BANK_SUB_SECTOR,
  MOTION_PIC_INDUSTRIES_SUB_SECTOR,
  MOTOR_VEHICLE_AND_PARTS_DEALERS_SUB_SECTOR,
  MUSEUMS_SUB_SECTOR,
  NATIONAL_SECURITY_SUB_SECTOR,
  NONDURABLE_GOODS_SUB_SECTOR,
  NONMETALLIC_MINERAL_MANUFACTURING_SUB_SECTOR,
  NURSING_FACILITIES_SUB_SECTOR,
  OIL_GAS_EXTRACTION_SUB_SECTOR,
  PAPER_MANUFACTURING_SUB_SECTOR,
  PERFORMING_ARTS_SUB_SECTOR,
  PETROLEUM_AND_COAL_MANUFACTURING_SUB_SECTOR,
  PIPELINE_TRANSPORTATION_SUB_SECTOR,
  PLASTICS_AND_RUBBER_MANUFACTURING_SUB_SECTOR,
  POSTAL_SERVICE_SUB_SECTOR,
  PRIMARY_METAL_MANUFACTURING_SUB_SECTOR,
  PRINTING_MANUFACTURING_SUB_SECTOR,
  PRIVATE_HOUSEHOLDS_SUB_SECTOR,
  PUBLISHING_INDUSTRIES_SUB_SECTOR,
  RAIL_TRANSPORTATION_SUB_SECTOR,
  REAL_ESTATE_SUB_SECTOR,
  RELIGIOUS_SUB_SECTOR,
  RENTAL_AND_LEASING_SUB_SECTOR,
  REPAIR_AND_MAINTENANCE_SUB_SECTOR,
  SCENIC_TRANSPORTATION_SUB_SECTOR,
  SECURITIES_COMMODITY_SUB_SECTOR,
  SOCIAL_ASSISTANCE_SUB_SECTOR,
  SPACE_RESEARCH_SUB_SECTOR,
  SPECIALTY_TRADE_CONTRACTORS_SUB_SECTOR,
  SPORTING_GOODS_RETAILERS_SUB_SECTOR,
  SUPPORT_ACTIVITIES_FOR_TRANSPORTATION_SUB_SECTOR,
  TELECOMMUNICATION_SUB_SECTOR,
  TEXTILE_MILLS_SUB_SECTOR,
  TEXTILE_PRODUCT_MILLS_SUB_SECTOR,
  TRANSIT_TRANSPORTATION_SUB_SECTOR,
  TRANSPORTATION_EQUIPMENT_MANUFACTURING_SUB_SECTOR,
  TRUCK_TRANSPORTATION_SUB_SECTOR,
  WAREHOUSING_AND_STORAGE_SUB_SECTOR,
  WASTE_MANAGEMENT_SUB_SECTOR,
  WATER_TRANSPORTATION_SUB_SECTOR,
  WEB_SEARCH_PORTALS_SUB_SECTOR,
  WOOD_PRODUCT_MANUFACTURING_SUB_SECTOR,
} from './industrySubSectorOptions';

export const OILSEED_AND_GRAIN_INDUSTRY_GROUP = '1111';
export const VEGETABLE_AND_MELON_INDUSTRY_GROUP = '1112';
export const FRUIT_AND_TREE_NUT_INDUSTRY_GROUP = '1113';
export const GREENHOUSE_NURSERY_AND_FLORICULTURE_INDUSTRY_GROUP = '1114';
export const OTHER_CROP_FARMING_INDUSTRY_GROUP = '1119';
export const CATTLE_RANCHING_FARMING_INDUSTRY_GROUP = '1121';
export const HOD_AND_PIG_FARMING_INDUSTRY_GROUP = '1122';
export const POULTRY_AND_EGG_INDUSTRY_GROUP = '1123';
export const SHEEP_AND_GOAT_INDUSTRY_GROUP = '1124';
export const AQUACULTURE_INDUSTRY_GROUP = '1125';
export const OTHER_ANIMAL_PRODUCTION_INDUSTRY_GROUP = '1129';
export const TIMBER_TRACK_OPERATIONS_INDUSTRY_GROUP = '1131';
export const FOREST_NURSERIES_INDUSTRY_GROUP = '1132';
export const LOGGING_INDUSTRY_GROUP = '1133';
export const FISHING_INDUSTRY_GROUP = '1141';
export const HUNTING_AND_TRAPPING_INDUSTRY_GROUP = '1142';
export const SUPPORT_ACTIVITIES_FOR_CROP_INDUSTRY_GROUP = '1151';
export const SUPPORT_ACTIVITIES_FOR_ANIMAL_INDUSTRY_GROUP = '1152';
export const SUPPORT_ACTIVITIES_FOR_FORESTRY_INDUSTRY_GROUP = '1153';
export const COAL_MINING_INDUSTRY_GROUP = '2121';
export const METAL_ORE_MINING_INDUSTRY_GROUP = '2122';
export const NONMETALLIC_MINERAL_MINING_INDUSTRY_GROUP = '2123';
export const ELECTRIC_POWER_GENERATION_INDUSTRY_GROUP = '2211';
export const NATURAL_GAS_DISTRIBUTION_INDUSTRY_GROUP = '2212';
export const RESIDENTIAL_BUILDING_CONSTRUCTION_INDUSTRY_GROUP = '2361';
export const NONRESIDENTIAL_BUILDING_CONSTRUCTION_INDUSTRY_GROUP = '2362';
export const UTILITY_SYSTEM_CONSTRUCTION_INDUSTRY_GROUP = '2371';
export const LAND_SUBDIVISION_INDUSTRY_GROUP = '2372';
export const HIGHWAY_CONSTRUCTION_INDUSTRY_GROUP = '2373';
export const OTHER_HEAVY_CONSTRUCTION_INDUSTRY_GROUP = '2379';
export const FOUNDATION_CONTRACTOR_INDUSTRY_GROUP = '2381';
export const BUILDING_EQUIPMENT_CONTRACTOR_INDUSTRY_GROUP = '2382';
export const BUILDING_FINISHING_CONTRACTOR_INDUSTRY_GROUP = '2383';
export const OTHER_SPECIALTY_TRADE_CONTRACTORS_INDUSTRY_GROUP = '2389';
export const ANIMAL_FOOD_MANUFACTURING_INDUSTRY_GROUP = '3111';
export const GRAIN_AND_OILSEED_MILLING_INDUSTRY_GROUP = '3112';
export const SUGAR_MANUFACTURING_INDUSTRY_GROUP = '3113';
export const FRUIT_PRESERVING_MANUFACTURING_INDUSTRY_GROUP = '3114';
export const DAIRY_MANUFACTURING_INDUSTRY_GROUP = '3115';
export const ANIMAL_SLAUGHTERING_INDUSTRY_GROUP = '3116';
export const SEAFOOD_PREPARATION_INDUSTRY_GROUP = '3117';
export const BAKERIES_MANUFACTURING_INDUSTRY_GROUP = '3118';
export const OTHER_FOOD_MANUFACTURING_INDUSTRY_GROUP = '3119';
export const BEVERAGE_MANUFACTURING_INDUSTRY_GROUP = '3121';
export const TOBACCO_MANUFACTURING_INDUSTRY_GROUP = '3122';
export const FIBER_YARN_MILLS_INDUSTRY_GROUP = '3131';
export const FABRIC_MILLS_INDUSTRY_GROUP = '3132';
export const TEXTILE_MILLS_INDUSTRY_GROUP = '3133';
export const TEXTILE_FURNISHING_MILLS_INDUSTRY_GROUP = '3141';
export const OTHER_TEXTILE_MILLS_INDUSTRY_GROUP = '3149';
export const APPAREL_KNITTING_MILLS_INDUSTRY_GROUP = '3151';
export const CUT_AND_SEW_APPAREL_INDUSTRY_GROUP = '3152';
export const APPAREL_ACCESSORIES_INDUSTRY_GROUP = '3159';
export const LEATHER_AND_HIDE_TANNING_INDUSTRY_GROUP = '3161';
export const FOOTWEAR_MANUFACTURING_INDUSTRY_GROUP = '3162';
export const OTHER_LEATHER_MANUFACTURING_INDUSTRY_GROUP = '3169';
export const SAWMILLS_AND_WOOD_PRESERVATION_INDUSTRY_GROUP = '3211';
export const VENEER_PLYWOOD_INDUSTRY_GROUP = '3212';
export const OTHER_WOOD_PRODUCT_INDUSTRY_GROUP = '3219';
export const PULP_PAPER_MILLS_INDUSTRY_GROUP = '3221';
export const CONVERTED_PAPER_MANUFACTURING_INDUSTRY_GROUP = '3222';
export const BASIC_CHEMICAL_MANUFACTURING_INDUSTRY_GROUP = '3251';
export const RESIN_SYNTHETIC_RUBBER_MANUFACTURING_INDUSTRY_GROUP = '3252';
export const PESTICIDE_FERTILIZER_MANUFACTURING_INDUSTRY_GROUP = '3253';
export const PHARMACEUTICAL_AND_MEDICINE_MANUFACTURING_INDUSTRY_GROUP = '3254';
export const PAINT_COATING_MANUFACTURING_INDUSTRY_GROUP = '3255';
export const SOAP_CLEANING_COMPOUND_MANUFACTURING_INDUSTRY_GROUP = '3256';
export const OTHER_CHEMICAL_MANUFACTURING_INDUSTRY_GROUP = '3259';
export const PLASTIC_MANUFACTURING_INDUSTRY_GROUP = '3261';
export const RUBBER_MANUFACTURING_INDUSTRY_GROUP = '3262';
export const CLAY_PRODUCT_MANUFACTURING_INDUSTRY_GROUP = '3271';
export const GLASS_MANUFACTURING_INDUSTRY_GROUP = '3272';
export const CEMENT_AND_CONCRETE_MANUFACTURING_INDUSTRY_GROUP = '3273';
export const LIME_AND_GYPSUM_MANUFACTURING_INDUSTRY_GROUP = '3274';
export const OTHER_NONMETALLIC_MANUFACTURING_INDUSTRY_GROUP = '3279';
export const IRON_AND_STEEL_MILLS_INDUSTRY_GROUP = '3311';
export const STEEL_PRODUCT_MANUFACTURING_INDUSTRY_GROUP = '3312';
export const ALUMINA_AND_ALUMINUM_PRODUCTION_INDUSTRY_GROUP = '3313';
export const NONFERROUS_METAL_PRODUCTION_INDUSTRY_GROUP = '3314';
export const FOUNDRIES_INDUSTRY_GROUP = '3315';
export const FORGING_AND_STAMPING_INDUSTRY_GROUP = '3321';
export const CUTLERY_AND_HANDTOOL_MANUFACTURING_INDUSTRY_GROUP = '3322';
export const ARCHITECTURAL_METALS_MANUFACTURING_INDUSTRY_GROUP = '3323';
export const BOILERS_TANK_MANUFACTURING_INDUSTRY_GROUP = '3324';
export const HARDWARE_MANUFACTURING_INDUSTRY_GROUP = '3325';
export const SPRING_AND_WIRE_MANUFACTURING_INDUSTRY_GROUP = '3326';
export const MACHINE_SHOPS_MANUFACTURING_INDUSTRY_GROUP = '3327';
export const COATING_ENGRAVING_HEAT_TREATING_INDUSTRY_GROUP = '3328';
export const OTHER_FABRICATED_TOOL_MANUFACTURING_INDUSTRY_GROUP = '3329';
export const AGRICULTURE_CONSTRUCTION_MANUFACTURING_INDUSTRY_GROUP = '3331';
export const INDUSTRIAL_MACHINERY_MANUFACTURING_INDUSTRY_GROUP = '3332';
export const COMMERCIAL_AND_SERVICE_INDUSTRY_MANUFACTURING_INDUSTRY_GROUP = '3333';
export const VENTILATION_HEATING_AIR_CONDITIONING_MANUFACTURING_INDUSTRY_GROUP = '3334';
export const METALWORKING_MACHINERY_MANUFACTURING_INDUSTRY_GROUP = '3335';
export const ENGINE_TURBINE_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP = '3336';
export const OTHER_GENERAL_PURPOSE_MACHINERY_MANUFACTURING_INDUSTRY_GROUP = '3339';
export const COMPUTER_MANUFACTURING_INDUSTRY_GROUP = '3341';
export const COMMUNICATION_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP = '3342';
export const AUDIO_VIDEO_MANUFACTURING_INDUSTRY_GROUP = '3343';
export const SEMICONDUCTOR_MANUFACTURING_INDUSTRY_GROUP = '3344';
export const NAVIGATIONAL_INSTRUMENTS_INDUSTRY_GROUP = '3345';
export const MANUFACTURING_AND_REPRODUCING_MAGNETIC_AND_OPTICAL_MEDIA_INDUSTRY_GROUP = '3346';
export const ELECTRIC_LIGHTING_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP = '3351';
export const HOUSEHOLD_APPLIANCE_MANUFACTURING_INDUSTRY_GROUP = '3352';
export const ELECTRICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP = '3353';
export const OTHER_ELECTRICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP = '3359';
export const MOTOR_VEHICLE_MANUFACTURING_INDUSTRY_GROUP = '3361';
export const VEHICLE_BODY_MANUFACTURING_INDUSTRY_GROUP = '3362';
export const VEHICLE_PARTS_MANUFACTURING_INDUSTRY_GROUP = '3363';
export const AEROSPACE_PRODUCT_MANUFACTURING_INDUSTRY_GROUP = '3364';
export const RAILROAD_MANUFACTURING_INDUSTRY_GROUP = '3365';
export const SHIP_AND_BOAT_BUILDING_INDUSTRY_GROUP = '3366';
export const OTHER_TRANSPORTATION_MANUFACTURING_INDUSTRY_GROUP = '3369';
export const HOUSEHOLD_MANUFACTURING_INDUSTRY_GROUP = '3371';
export const OFFICE_FURNITURE_MANUFACTURING_INDUSTRY_GROUP = '3372';
export const OTHER_FURNITURE_MANUFACTURING_INDUSTRY_GROUP = '3379';
export const MEDICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP = '3391';
export const OTHER_MISCELLANEOUS_MANUFACTURING_INDUSTRY_GROUP = '3399';
export const MOTOR_VEHICLE_WHOLESALERS_INDUSTRY_GROUP = '4231';
export const FURNITURE_AND_HONE_WHOLESALERS_INDUSTRY_GROUP = '4232';
export const LUMBER_WHOLESALERS_INDUSTRY_GROUP = '4233';
export const PROF_AND_COMMERCIAL_EQUIPMENT_WHOLESALERS_INDUSTRY_GROUP = '4234';
export const METAL_AND_MINERAL_WHOLESALERS_INDUSTRY_GROUP = '4235';
export const HOUSEHOLD_APPLIANCES_WHOLESALERS_INDUSTRY_GROUP = '4236';
export const HARDWARE_AND_PLUMBING_WHOLESALERS_INDUSTRY_GROUP = '4237';
export const MACHINERY_WHOLESALERS_INDUSTRY_GROUP = '4238';
export const MISCELLANEOUS_DURABLE_GOODS_WHOLESALERS_INDUSTRY_GROUP = '4239';
export const PAPER_AND_PRODUCT_WHOLESALERS_INDUSTRY_GROUP = '4241';
export const DRUGS_WHOLESALERS_INDUSTRY_GROUP = '4242';
export const APPAREL_PIECE_GOODS_WHOLESALERS_INDUSTRY_GROUP = '4243';
export const GROCERY_WHOLESALERS_INDUSTRY_GROUP = '4244';
export const FARM_PRODUCT_WHOLESALERS_INDUSTRY_GROUP = '4245';
export const CHEMICAL_AND_ALLIED_PRODUCTS_WHOLESALERS_INDUSTRY_GROUP = '4246';
export const PETROLEUM_WHOLESALERS_INDUSTRY_GROUP = '4247';
export const BEER_WINE_WHOLESALERS_INDUSTRY_GROUP = '4248';
export const MISCELLANEOUS_NONDURABLE_GOODS_WHOLESALERS_INDUSTRY_GROUP = '4249';
export const AUTO_DEALERS_INDUSTRY_GROUP = '441';
export const OTHER_MOTOR_DEALERS_INDUSTRY_GROUP = '4412';
export const AUTOMOTIVE_PARTS_INDUSTRY_GROUP = '4413';
export const BUILDING_MATERIAL_AND_SUPPLIES_DEALERS_INDUSTRY_GROUP = '4441';
export const LAWN_AND_GARDEN_EQUIPMENT_INDUSTRY_GROUP = '4442';
export const GROCERY_RETAILERS_INDUSTRY_GROUP = '4451';
export const SPECIALTY_FOOD_RETAILERS_INDUSTRY_GROUP = '4452';
export const BEER_WINE_LIQUOR_RETAILERS_INDUSTRY_GROUP = '4453';
export const FURNITURE_RETAILERS_INDUSTRY_GROUP = '4491';
export const ELECTRONICS_RETAILERS_INDUSTRY_GROUP = '4492';
export const DEPARTMENT_STORE_INDUSTRY_GROUP = '4551';
export const WAREHOUSE_CLUBS_RETAILERS_INDUSTRY_GROUP = '4552';
export const GASOLINE_STATIONS_INDUSTRY_GROUP = '4571';
export const FUEL_DEALERS_INDUSTRY_GROUP = '4572';
export const CLOTHING_RETAILERS_INDUSTRY_GROUP = '4581';
export const SHOE_RETAILERS_INDUSTRY_GROUP = '4582';
export const JEWELRY_RETAILERS_INDUSTRY_GROUP = '4583';
export const SPORTING_GOODS_RETAILERS_INDUSTRY_GROUP = '4591';
export const BOOK_RETAILERS_INDUSTRY_GROUP = '4592';
export const FLORISTS_INDUSTRY_GROUP = '4593 ';
export const OFFICE_SUPPLY_RETAILERS_INDUSTRY_GROUP = '4594';
export const USED_MERCHANDISE_INDUSTRY_GROUP = '4595';
export const OTHER_MISCELLANEOUS_INDUSTRY_GROUP = '4599';
export const SCHEDULED_AIR_TRANSPORTATION_INDUSTRY_GROUP = '4811';
export const NONSCHEDULED_AIR_TRANSPORTATION_INDUSTRY_GROUP = '4812';
export const DEEP_SEA_TRANSPORTATION_INDUSTRY_GROUP = '4831';
export const INLAND_WATER_TRANSPORTATION_INDUSTRY_GROUP = '4832';
export const GENERAL_FREIGHT_TRUCKING_INDUSTRY_GROUP = '4841';
export const SPECIALIZED_FREIGHT_TRUCKING_INDUSTRY_GROUP = '4842';
export const URBAN_TRANSIT_SYSTEMS_INDUSTRY_GROUP = '4851';
export const INTERURBAN_TRANSPORTATION_INDUSTRY_GROUP = '4852';
export const TAXI_SERVICE_INDUSTRY_GROUP = '4853';
export const SCHOOL_TRANSPORTATION_INDUSTRY_GROUP = '4854';
export const CHARTER_BUS_INDUSTRY_GROUP = '4855';
export const OTHER_TRANSIT_TRANSPORTATION_INDUSTRY_GROUP = '4859';
export const CRUDE_OIL_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP = '4861';
export const NATURAL_GAS_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP = '4862';
export const OTHER_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP = '4869';
export const SCENIC_LAND_INDUSTRY_GROUP = '4871';
export const SCENIC_WATER_INDUSTRY_GROUP = '4872';
export const SCENIC_OTHER_INDUSTRY_GROUP = '4879';
export const SUPPORT_FOR_AIR_TRANSPORTATION_INDUSTRY_GROUP = '4881';
export const SUPPORT_FOR_RAIL_TRANSPORTATION_INDUSTRY_GROUP = '4882';
export const SUPPORT_FOR_WATER_TRANSPORTATION_INDUSTRY_GROUP = '4883';
export const SUPPORT_FOR_ROAD_TRANSPORTATION_INDUSTRY_GROUP = '4884';
export const FREIGHT_TRANSPORTATION_AGREEMENT_INDUSTRY_GROUP = '4885';
export const OTHER_SUPPORT_TRANSPORTATION_INDUSTRY_GROUP = '4889';
export const COURIER_DELIVERY_INDUSTRY_GROUP = '4921';
export const LOCAL_DELIVERY_INDUSTRY_GROUP = '4922';
export const MOTION_PICTURE_INDUSTRY_GROUP = '5121';
export const SOUND_INDUSTRY_GROUP = '5122';
export const NEWSPAPER_INDUSTRY_GROUP = '5131';
export const SOFTWARE_PUBLISHERS_INDUSTRY_GROUP = '5132';
export const RADIO_AND_TELEVISION_INDUSTRY_GROUP = '5161';
export const MEDIA_STREAMING_INDUSTRY_GROUP = '5162';
export const WIRED_TELECOMMUNICATIONS_INDUSTRY_GROUP = '5171';
export const SATELLITE_TELECOMMUNICATIONS_INDUSTRY_GROUP = '5174';
export const OTHER_TELECOMMUNICATIONS_INDUSTRY_GROUP = '5178';
export const DEPOSITORY_INTERMEDIATION_INDUSTRY_GROUP = '5221';
export const NONDEPOSITORY_INTERMEDIATION_INDUSTRY_GROUP = '5222';
export const ACTIVITIES_RELATED_TO_CREDIT_INTERMEDIATION_INDUSTRY_GROUP = '5223';
export const COMMODITY_CONTRACTS_INDUSTRY_GROUP = '5231';
export const COMMODITY_EXCHANGES_INDUSTRY_GROUP = '5232';
export const OTHER_FINANCIAL_INVESTMENT_ACTIVITIES_INDUSTRY_GROUP = '5239';
export const INSURANCE_CARRIER_INDUSTRY_GROUP = '5241';
export const AGENCIES_BROKERAGES_INDUSTRY_GROUP = '5242';
export const INSURANCE_FUNDS_INDUSTRY_GROUP = '5251';
export const OTHER_FUNDS_FUNDS_INDUSTRY_GROUP = '5259';
export const LESSORS_OF_REAL_ESTATE_INDUSTRY_GROUP = '5311';
export const OFFICES_OF_REAL_ESTATE_INDUSTRY_GROUP = '5312';
export const ACTIVITIES_RELATED_TO_REAL_ESTATE_INDUSTRY_GROUP = '5313';
export const AUTOMOTIVE_LEASING_INDUSTRY_GROUP = '5321';
export const CONSUMER_GOODS_RENTAL_INDUSTRY_GROUP = '5322';
export const GENERAL_RENTAL_CENTERS_INDUSTRY_GROUP = '5323';
export const COMMERCIAL_MACHINERY_INDUSTRY_GROUP = '5324';
export const LEGAL_SERVICES_INDUSTRY_GROUP = '5411';
export const ACCOUNTING_SERVICES_INDUSTRY_GROUP = '5412';
export const ARCHITECTURAL_SERVICES_INDUSTRY_GROUP = '5413';
export const DESIGN_SERVICES_INDUSTRY_GROUP = '5414';
export const COMPUTER_SYSTEMS_DESIGN_SERVICES_INDUSTRY_GROUP = '5415';
export const TECHNICAL_CONSULTING_SERVICES_INDUSTRY_GROUP = '5416';
export const SCIENTIFIC_RESEARCH_SERVICES_INDUSTRY_GROUP = '5417';
export const ADVERTISING_SERVICES_INDUSTRY_GROUP = '5418';
export const OTHER_TECHNICAL_SERVICES_INDUSTRY_GROUP = '5419';
export const OFFICE_ADMINISTRATIVE_SERVICES_INDUSTRY_GROUP = '5611';
export const FACILITIES_SUPPORT_SERVICES_INDUSTRY_GROUP = '5612';
export const EMPLOYMENTS_SERVICES_INDUSTRY_GROUP = '5613';
export const BUSINESS_SUPPORT_SERVICES_INDUSTRY_GROUP = '5614';
export const RESERVATION_SERVICES_INDUSTRY_GROUP = '5615';
export const INVESTIGATION_AND_SECURITY_SERVICES_INDUSTRY_GROUP = '5616';
export const SERVICES_TO_BUILDINGS_INDUSTRY_GROUP = '5617';
export const OTHER_SUPPORT_SERVICES_INDUSTRY_GROUP = '5619';
export const WASTE_COLLECTION_INDUSTRY_GROUP = '5621';
export const WASTE_DISPOSAL_INDUSTRY_GROUP = '5622';
export const REMEDIATION_AND_OTHER_WASTE_MANAGEMENT_SERVICE_INDUSTRY_GROUP = '5629';
export const ELEMENTARY_SCHOOLS_INDUSTRY_GROUP = '6111';
export const JUNIOR_COLLEGES_INDUSTRY_GROUP = '6112';
export const PROFESSIONAL_SCHOOLS_INDUSTRY_GROUP = '6113';
export const BUSINESS_SCHOOLS_INDUSTRY_GROUP = '6114';
export const TRADE_SCHOOLS_INDUSTRY_GROUP = '6115';
export const OTHER_SCHOOLS_INDUSTRY_GROUP = '6116';
export const EDUCATIONAL_SUPPORT_SERVICES_INDUSTRY_GROUP = '6117';
export const PHYSICIANS_INDUSTRY_GROUP = '6211';
export const DENTISTS_INDUSTRY_GROUP = '6212';
export const OTHER_HEALTH_PRACTITIONERS_INDUSTRY_GROUP = '6213';
export const OUTPATIENT_CARE_CENTERS_INDUSTRY_GROUP = '6214';
export const MEDICAL_LABS_INDUSTRY_GROUP = '6215';
export const HOME_HEALTH_CARE_SERVICES_INDUSTRY_GROUP = '6216';
export const OTHER_AMBULATORY_HEALTH_CARE_INDUSTRY_GROUP = '6219';
export const GENERAL_MEDICAL_INDUSTRY_GROUP = '6221';
export const SUBSTANCE_ABUSE_HOSPITALS_INDUSTRY_GROUP = '6222';
export const SPECIALTY_HOSPITALS__INDUSTRY_GROUP = '6223';
export const NURSING_CARE_FACILITIES_INDUSTRY_GROUP = '6231';
export const RESIDENTIAL_INTELLECTUAL_INDUSTRY_GROUP = '6232';
export const RETIREMENT_COMMUNITIES_INDUSTRY_GROUP = '6233';
export const OTHER_RESIDENTIAL_CARE_INDUSTRY_GROUP = '6239';
export const INDIVIDUAL_AND_FAMILY_SERVICES_INDUSTRY_GROUP = '6241';
export const OTHER_RELIEF_SERVICES_INDUSTRY_GROUP = '6242';
export const VOCATIONAL_REHABILITATION_SERVICES_INDUSTRY_GROUP = '6243';
export const CHILD_CARE_SERVICES_INDUSTRY_GROUP = '6244';
export const PERFORMING_ARTS_COMPANIES_INDUSTRY_GROUP = '7111';
export const SPECTATOR_SPORTS_INDUSTRY_GROUP = '7112';
export const PROMOTERS_OF_PERFORMING_ARTS_INDUSTRY_GROUP = '7113';
export const ARTISTS_AGENTS_AND_MANAGERS_INDUSTRY_GROUP = '7114';
export const INDEPENDENT_ARTISTS_INDUSTRY_GROUP = '7115';
export const AMUSEMENT_PARKS_INDUSTRY_GROUP = '7131';
export const GAMBLING_INDUSTRIES_INDUSTRY_GROUP = '7132';
export const OTHER_AMUSEMENT_INDUSTRY_GROUP = '7139';
export const TRAVELER_ACCOMMODATION_INDUSTRY_GROUP = '7211';
export const RECREATIONAL_CAMPS_INDUSTRY_GROUP = '7212';
export const WORKERS_CAMPS_INDUSTRY_GROUP = '7213';
export const SPECIAL_FOOD_SERVICES_INDUSTRY_GROUP = '7223';
export const DRINKING_PLACES_INDUSTRY_GROUP = '7224';
export const OTHER_EATING_PLACES_INDUSTRY_GROUP = '7225';
export const AUTOMOTIVE_REPAIR_INDUSTRY_GROUP = '8111';
export const ELECTRONICS_REPAIR_INDUSTRY_GROUP = '8112';
export const COMMERCIAL_REPAIR_AND_MAINTENANCE_INDUSTRY_GROUP = '8113';
export const PERSONAL_GOODS_REPAIR_INDUSTRY_GROUP = '8114';
export const PERSONAL_CARE_SERVICES_INDUSTRY_GROUP = '8121';
export const DEATH_CARE_SERVICES_INDUSTRY_GROUP = '8122';
export const LAUNDRY_SERVICES_INDUSTRY_GROUP = '8123';
export const OTHER_PERSONAL_SERVICES_INDUSTRY_GROUP = '8129';
export const RELIGIOUS_ORGANIZATIONS_INDUSTRY_GROUP = '8131';
export const GRANTMAKING_INDUSTRY_GROUP = '8132';
export const SOCIAL_ADVOCACY_INDUSTRY_GROUP = '8133';
export const SOCIAL_ORGANIZATIONS_INDUSTRY_GROUP = '8134';
export const BUSINESS_LABOR_POLITICAL_INDUSTRY_GROUP = '8139';

export const INDUSTRY_GROUP_OPTIONS = {
  [CROP_PRODUCTION_SUB_SECTOR]: [
    { value: OILSEED_AND_GRAIN_INDUSTRY_GROUP, label: 'Oilseed and Grain Farming' },
    { value: VEGETABLE_AND_MELON_INDUSTRY_GROUP, label: 'Vegetable and Melon Farming' },
    { value: FRUIT_AND_TREE_NUT_INDUSTRY_GROUP, label: 'Fruit and Tree Nut Farming' },
    {
      value: GREENHOUSE_NURSERY_AND_FLORICULTURE_INDUSTRY_GROUP,
      label: 'Greenhouse, Nursery, and Floriculture Production',
    },
    { value: OTHER_CROP_FARMING_INDUSTRY_GROUP, label: 'Other Crop Farming' },
  ],
  [ANIMAL_AND_AGRICULTURE_SUB_SECTOR]: [
    { value: CATTLE_RANCHING_FARMING_INDUSTRY_GROUP, label: 'Cattle Ranching and Farming' },
    { value: HOD_AND_PIG_FARMING_INDUSTRY_GROUP, label: 'Hog and Pig Farming' },
    { value: POULTRY_AND_EGG_INDUSTRY_GROUP, label: 'Poultry and Egg Production' },
    { value: SHEEP_AND_GOAT_INDUSTRY_GROUP, label: 'Sheep and Goat Farming' },
    { value: AQUACULTURE_INDUSTRY_GROUP, label: 'Aquaculture' },
    { value: OTHER_ANIMAL_PRODUCTION_INDUSTRY_GROUP, label: 'Other Animal Production' },
  ],
  [FORESTRY_AND_LOGGING_SUB_SECTOR]: [
    { value: TIMBER_TRACK_OPERATIONS_INDUSTRY_GROUP, label: 'Timber Tract Operations' },
    { value: FOREST_NURSERIES_INDUSTRY_GROUP, label: 'Forest Nurseries and Gathering of Forest Products' },
    { value: LOGGING_INDUSTRY_GROUP, label: 'Logging' },
  ],
  [FISHING_HUNTING_TRAPPING_SUB_SECTOR]: [
    { value: FISHING_INDUSTRY_GROUP, label: 'Fishing' },
    { value: HUNTING_AND_TRAPPING_INDUSTRY_GROUP, label: 'Hunting and Trapping' },
  ],
  [AGRICULTURE_SUPPORT_ACTIVITIES_SUB_SECTOR]: [
    { value: SUPPORT_ACTIVITIES_FOR_CROP_INDUSTRY_GROUP, label: 'Support Activities for Agriculture and Forestry' },
    { value: SUPPORT_ACTIVITIES_FOR_ANIMAL_INDUSTRY_GROUP, label: 'Support Activities for Animal Production' },
    { value: SUPPORT_ACTIVITIES_FOR_FORESTRY_INDUSTRY_GROUP, label: 'Support Activities for Forestry' },
  ],
  [OIL_GAS_EXTRACTION_SUB_SECTOR]: [], 
  [MINING_SUB_SECTOR]: [
    { value: COAL_MINING_INDUSTRY_GROUP, label: 'Coal Mining' },
    { value: METAL_ORE_MINING_INDUSTRY_GROUP, label: 'Metal Ore Mining' },
    { value: NONMETALLIC_MINERAL_MINING_INDUSTRY_GROUP, label: 'Nonmetallic Mineral Mining and Quarrying' },
  ],
  [MINING_SUPPORT_ACTIVITIES_SUB_SECTOR]: [],
  [UTILITIES_SECTOR]: [
    {
      value: ELECTRIC_POWER_GENERATION_INDUSTRY_GROUP,
      label: 'Electric Power Generation, Transmission and Distribution',
    },
    {
      value: NATURAL_GAS_DISTRIBUTION_INDUSTRY_GROUP,
      label: 'Natural Gas Distribution',
    },
  ],
  [BUILDING_CONSTRUCTION_SUB_SECTOR]: [
    { value: RESIDENTIAL_BUILDING_CONSTRUCTION_INDUSTRY_GROUP, label: 'Residential Building Construction' },
    { value: NONRESIDENTIAL_BUILDING_CONSTRUCTION_INDUSTRY_GROUP, label: 'Nonresidential Building Construction' },
  ],
  [HEAVY_AND_CIVIL_ENGINEERING_CONSTRUCTION_SUB_SECTOR]: [
    { value: UTILITY_SYSTEM_CONSTRUCTION_INDUSTRY_GROUP, label: 'Utility System Construction' },
    { value: LAND_SUBDIVISION_INDUSTRY_GROUP, label: 'Land Subdivision' },
    { value: HIGHWAY_CONSTRUCTION_INDUSTRY_GROUP, label: 'Highway, Street, and Bridge Construction' },
    { value: OTHER_HEAVY_CONSTRUCTION_INDUSTRY_GROUP, label: 'Other Heavy and Civil Engineering Construction' },
  ],
  [SPECIALTY_TRADE_CONTRACTORS_SUB_SECTOR]: [
    { value: FOUNDATION_CONTRACTOR_INDUSTRY_GROUP, label: 'Foundation, Structure, and Building Exterior Contractors' },
    { value: BUILDING_EQUIPMENT_CONTRACTOR_INDUSTRY_GROUP, label: 'Building Equipment Contractors' },
    { value: BUILDING_FINISHING_CONTRACTOR_INDUSTRY_GROUP, label: 'Building Finishing Contractors' },
    { value: OTHER_SPECIALTY_TRADE_CONTRACTORS_INDUSTRY_GROUP, label: 'Other Specialty Trade Contractors' },
  ],
  [FOOD_MANUFACTURING_SUB_SECTOR]: [
    { value: ANIMAL_FOOD_MANUFACTURING_INDUSTRY_GROUP, label: 'Animal Food Manufacturing' },
    { value: GRAIN_AND_OILSEED_MILLING_INDUSTRY_GROUP, label: 'Grain and Oilseed Milling' },
    { value: SUGAR_MANUFACTURING_INDUSTRY_GROUP, label: 'Sugar and Confectionery Product Manufacturing' },
    {
      value: FRUIT_PRESERVING_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fruit and Vegetable Preserving and Specialty Food Manufacturing',
    },
    { value: DAIRY_MANUFACTURING_INDUSTRY_GROUP, label: 'Dairy Product Manufacturing' },
    { value: ANIMAL_SLAUGHTERING_INDUSTRY_GROUP, label: 'Animal Slaughtering and Processing' },
    { value: SEAFOOD_PREPARATION_INDUSTRY_GROUP, label: 'Seafood Product Preparation and Packaging' },
    { value: BAKERIES_MANUFACTURING_INDUSTRY_GROUP, label: 'Bakeries and Tortilla Manufacturing' },
    { value: OTHER_FOOD_MANUFACTURING_INDUSTRY_GROUP, label: 'Other Food Manufacturing' },
  ],
  [BEVERAGE_AND_TOBACCO_MANUFACTURING_SUB_SECTOR]: [
    { value: BEVERAGE_MANUFACTURING_INDUSTRY_GROUP, label: 'Beverage Manufacturing' },
    { value: TOBACCO_MANUFACTURING_INDUSTRY_GROUP, label: 'Tobacco Manufacturing' },
  ],
  [TEXTILE_MILLS_SUB_SECTOR]: [
    { value: FIBER_YARN_MILLS_INDUSTRY_GROUP, label: 'Fiber, Yarn, and Thread Mills' },
    { value: FABRIC_MILLS_INDUSTRY_GROUP, label: 'Fabric Mills' },
    { value: TEXTILE_MILLS_INDUSTRY_GROUP, label: 'Textile and Fabric Finishing and Fabric Coating Mills' },
  ],
  [TEXTILE_PRODUCT_MILLS_SUB_SECTOR]: [
    { value: TEXTILE_FURNISHING_MILLS_INDUSTRY_GROUP, label: 'Textile Furnishings Mills' },
    { value: OTHER_TEXTILE_MILLS_INDUSTRY_GROUP, label: 'Other Textile Product Mills' },
  ],
  [APPAREL_MANUFACTURING_SUB_SECTOR]: [
    { value: APPAREL_KNITTING_MILLS_INDUSTRY_GROUP, label: 'Apparel Knitting Mills' },
    { value: CUT_AND_SEW_APPAREL_INDUSTRY_GROUP, label: 'Cut and Sew Apparel Manufacturing' },
    { value: APPAREL_ACCESSORIES_INDUSTRY_GROUP, label: 'Apparel Accessories and Other Apparel Manufacturing' },
  ],
  [LEATHER_AND_ALLIED_PRODUCT_MANUFACTURING_SUB_SECTOR]: [
    { value: LEATHER_AND_HIDE_TANNING_INDUSTRY_GROUP, label: 'Leather and Hide Tanning and Finishing' },
    { value: FOOTWEAR_MANUFACTURING_INDUSTRY_GROUP, label: 'Footwear Manufacturing' },
    { value: OTHER_LEATHER_MANUFACTURING_INDUSTRY_GROUP, label: 'Other Leather and Allied Product Manufacturing' },
  ],
  [WOOD_PRODUCT_MANUFACTURING_SUB_SECTOR]: [
    { value: SAWMILLS_AND_WOOD_PRESERVATION_INDUSTRY_GROUP, label: 'Sawmills and Wood Preservation' },
    { value: VENEER_PLYWOOD_INDUSTRY_GROUP, label: 'Veneer, Plywood, and Engineered Wood Product Manufacturing' },
    { value: OTHER_WOOD_PRODUCT_INDUSTRY_GROUP, label: 'Other Wood Product Manufacturing' },
  ],
  [PAPER_MANUFACTURING_SUB_SECTOR]: [
    { value: PULP_PAPER_MILLS_INDUSTRY_GROUP, label: 'Pulp, Paper, and Paperboard Mills' },
    { value: CONVERTED_PAPER_MANUFACTURING_INDUSTRY_GROUP, label: 'Converted Paper Product Manufacturing' },
  ],
  [PRINTING_MANUFACTURING_SUB_SECTOR]: [],
  [PETROLEUM_AND_COAL_MANUFACTURING_SUB_SECTOR]: [],
  [CHEMICAL_MANUFACTURING_SUB_SECTOR]: [
    { value: BASIC_CHEMICAL_MANUFACTURING_INDUSTRY_GROUP, label: 'Basic Chemical Manufacturing' },
    {
      value: RESIN_SYNTHETIC_RUBBER_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Resin, Synthetic Rubber, and Artificial and Synthetic Fibers and Filaments Manufacturing',
    },
    {
      value: PESTICIDE_FERTILIZER_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Pesticide, Fertilizer, and Other Agricultural Chemical Manufacturing',
    },
    {
      value: PHARMACEUTICAL_AND_MEDICINE_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Pharmaceutical and Medicine Manufacturing',
    },
    { value: PAINT_COATING_MANUFACTURING_INDUSTRY_GROUP, label: 'Paint, Coating, and Adhesive Manufacturing' },
    {
      value: SOAP_CLEANING_COMPOUND_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Soap, Cleaning Compound, and Toilet Preparation Manufacturing',
    },
    {
      value: OTHER_CHEMICAL_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Other Chemical Product and Preparation Manufacturing',
    },
  ],
  [PLASTICS_AND_RUBBER_MANUFACTURING_SUB_SECTOR]: [
    { value: PLASTIC_MANUFACTURING_INDUSTRY_GROUP, label: 'Plastics Product Manufacturing' },
    { value: RUBBER_MANUFACTURING_INDUSTRY_GROUP, label: 'Rubber Product Manufacturing' },
  ],
  [NONMETALLIC_MINERAL_MANUFACTURING_SUB_SECTOR]: [
    { value: CLAY_PRODUCT_MANUFACTURING_INDUSTRY_GROUP, label: 'Clay Product and Refractory Manufacturing' },
    { value: GLASS_MANUFACTURING_INDUSTRY_GROUP, label: 'Glass and Glass Product Manufacturing' },
    { value: CEMENT_AND_CONCRETE_MANUFACTURING_INDUSTRY_GROUP, label: 'Cement and Concrete Product Manufacturing' },
    { value: LIME_AND_GYPSUM_MANUFACTURING_INDUSTRY_GROUP, label: 'Lime and Gypsum Product Manufacturing' },
    { value: OTHER_NONMETALLIC_MANUFACTURING_INDUSTRY_GROUP, label: 'Other Nonmetallic Mineral Product Manufacturing' },
  ],
  [PRIMARY_METAL_MANUFACTURING_SUB_SECTOR]: [
    { value: IRON_AND_STEEL_MILLS_INDUSTRY_GROUP, label: 'Iron and Steel Mills and Ferroalloy Manufacturing' },
    { value: STEEL_PRODUCT_MANUFACTURING_INDUSTRY_GROUP, label: 'Steel Product Manufacturing from Purchased Steel' },
    { value: ALUMINA_AND_ALUMINUM_PRODUCTION_INDUSTRY_GROUP, label: 'Alumina and Aluminum Production and Processing' },
    {
      value: NONFERROUS_METAL_PRODUCTION_INDUSTRY_GROUP,
      label: 'Nonferrous Metal (except Aluminum) Production and Processing',
    },
    { value: FOUNDRIES_INDUSTRY_GROUP, label: 'Foundries' },
  ],
  [FABRICATED_METAL_MANUFACTURING_SUB_SECTOR]: [
    { value: FORGING_AND_STAMPING_INDUSTRY_GROUP, label: 'Forging and Stamping' },
    { value: CUTLERY_AND_HANDTOOL_MANUFACTURING_INDUSTRY_GROUP, label: 'Cutlery and Handtool Manufacturing' },
    {
      value: ARCHITECTURAL_METALS_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Architectural and Structural Metals Manufacturing',
    },
    { value: BOILERS_TANK_MANUFACTURING_INDUSTRY_GROUP, label: 'Boiler, Tank, and Shipping Container Manufacturing' },
    { value: HARDWARE_MANUFACTURING_INDUSTRY_GROUP, label: 'Hardware Manufacturing' },
    { value: SPRING_AND_WIRE_MANUFACTURING_INDUSTRY_GROUP, label: 'Spring and Wire Product Manufacturing' },
    {
      value: MACHINE_SHOPS_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Machine Shops; Turned Product; and Screw, Nut, and Bolt Manufacturing',
    },
    {
      value: COATING_ENGRAVING_HEAT_TREATING_INDUSTRY_GROUP,
      label: 'Coating, Engraving, Heat Treating, and Allied Activities',
    },
    {
      value: OTHER_FABRICATED_TOOL_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Other Fabricated Metal Product Manufacturing',
    },
  ],
  [MACHINERY_MANUFACTURING_SUB_SECTOR]: [
    {
      value: AGRICULTURE_CONSTRUCTION_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Agriculture, Construction, and Mining Machinery Manufacturing',
    },
    { value: INDUSTRIAL_MACHINERY_MANUFACTURING_INDUSTRY_GROUP, label: 'Industrial Machinery Manufacturing' },
    {
      value: COMMERCIAL_AND_SERVICE_INDUSTRY_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Commercial and Service Industry Machinery Manufacturing',
    },
    {
      value: VENTILATION_HEATING_AIR_CONDITIONING_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Ventilation, Heating, Air-Conditioning, and Commercial Refrigeration Equipment Manufacturing',
    },
    { value: METALWORKING_MACHINERY_MANUFACTURING_INDUSTRY_GROUP, label: 'Metalworking Machinery Manufacturing' },
    {
      value: ENGINE_TURBINE_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Engine, Turbine, and Power Transmission Equipment Manufacturing',
    },
    {
      value: OTHER_GENERAL_PURPOSE_MACHINERY_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Other General Purpose Machinery Manufacturing',
    },
  ],
  [COMPUTER_AND_ELECTRONIC_MANUFACTURING_SUB_SECTOR]: [
    { value: COMPUTER_MANUFACTURING_INDUSTRY_GROUP, label: 'Computer and Peripheral Equipment Manufacturing' },
    { value: COMMUNICATION_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP, label: 'Communications Equipment Manufacturing' },
    { value: AUDIO_VIDEO_MANUFACTURING_INDUSTRY_GROUP, label: 'Audio and Video Equipment Manufacturing' },
    {
      value: SEMICONDUCTOR_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Semiconductor and Other Electronic Component Manufacturing',
    },
    {
      value: NAVIGATIONAL_INSTRUMENTS_INDUSTRY_GROUP,
      label: 'Navigational, Measuring, Electromedical, and Control Instruments Manufacturing',
    },
    {
      value: MANUFACTURING_AND_REPRODUCING_MAGNETIC_AND_OPTICAL_MEDIA_INDUSTRY_GROUP,
      label: 'Manufacturing and Reproducing Magnetic and Optical Media',
    },
  ],
  [ELECTRICAL_EQUIPMENT_MANUFACTURING_SUB_SECTOR]: [
    {
      value: ELECTRIC_LIGHTING_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Electric Lighting Equipment Manufacturing',
    },
    { value: HOUSEHOLD_APPLIANCE_MANUFACTURING_INDUSTRY_GROUP, label: 'Household Appliance Manufacturing' },
    { value: ELECTRICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP, label: 'Electrical Equipment Manufacturing' },
    {
      value: OTHER_ELECTRICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Other Electrical Equipment and Component Manufacturing',
    },
  ],
  [TRANSPORTATION_EQUIPMENT_MANUFACTURING_SUB_SECTOR]: [
    { value: MOTOR_VEHICLE_MANUFACTURING_INDUSTRY_GROUP, label: 'Motor Vehicle Manufacturing' },
    { value: VEHICLE_BODY_MANUFACTURING_INDUSTRY_GROUP, label: 'Motor Vehicle Body and Trailer Manufacturing' },
    { value: VEHICLE_PARTS_MANUFACTURING_INDUSTRY_GROUP, label: 'Motor Vehicle Parts Manufacturing' },
    { value: AEROSPACE_PRODUCT_MANUFACTURING_INDUSTRY_GROUP, label: 'Aerospace Product and Parts Manufacturing' },
    { value: RAILROAD_MANUFACTURING_INDUSTRY_GROUP, label: 'Railroad Rolling Stock Manufacturing' },
    { value: SHIP_AND_BOAT_BUILDING_INDUSTRY_GROUP, label: 'Ship and Boat Building' },
    { value: OTHER_TRANSPORTATION_MANUFACTURING_INDUSTRY_GROUP, label: 'Other Transportation Equipment Manufacturing' },
  ],
  [FURNITURE_MANUFACTURING_SUB_SECTOR]: [
    {
      value: HOUSEHOLD_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Household and Institutional Furniture and Kitchen Cabinet Manufacturing',
    },
    {
      value: OFFICE_FURNITURE_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Office Furniture (including Fixtures) Manufacturing',
    },
    { value: OTHER_FURNITURE_MANUFACTURING_INDUSTRY_GROUP, label: 'Other Furniture Related Product Manufacturing' },
  ],
  [MISCELLANEOUS_MANUFACTURING_SUB_SECTOR]: [
    { value: MEDICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP, label: 'Medical Equipment and Supplies Manufacturing' },
    { value: OTHER_MISCELLANEOUS_MANUFACTURING_INDUSTRY_GROUP, label: 'Other Miscellaneous Manufacturing' },
  ],
  [DURABLE_GOODS_SUB_SECTOR]: [
    {
      value: MOTOR_VEHICLE_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Motor Vehicle and Motor Vehicle Parts and Supplies Merchant Wholesalers',
    },
    {
      value: FURNITURE_AND_HONE_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Furniture and Home Furnishing Merchant Wholesalers',
    },
    { value: LUMBER_WHOLESALERS_INDUSTRY_GROUP, label: 'Lumber and Other Construction Materials Merchant Wholesalers' },
    {
      value: PROF_AND_COMMERCIAL_EQUIPMENT_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Professional and Commercial Equipment and Supplies Merchant Wholesalers',
    },
    {
      value: METAL_AND_MINERAL_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Metal and Mineral (except Petroleum) Merchant Wholesalers',
    },
    {
      value: HOUSEHOLD_APPLIANCES_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Household Appliances and Electrical and Electronic Goods Merchant Wholesalers',
    },
    {
      value: HARDWARE_AND_PLUMBING_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Hardware, and Plumbing and Heating Equipment and Supplies Merchant Wholesalers',
    },
    { value: MACHINERY_WHOLESALERS_INDUSTRY_GROUP, label: 'Machinery, Equipment, and Supplies Merchant Wholesalers' },
    {
      value: MISCELLANEOUS_DURABLE_GOODS_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Miscellaneous Durable Goods Merchant Wholesalers',
    },
  ],
  [NONDURABLE_GOODS_SUB_SECTOR]: [
    { value: PAPER_AND_PRODUCT_WHOLESALERS_INDUSTRY_GROUP, label: 'Paper and Paper Product Merchant Wholesalers' },
    { value: DRUGS_WHOLESALERS_INDUSTRY_GROUP, label: "Drugs and Druggists' Sundries Merchant Wholesalers" },
    {
      value: APPAREL_PIECE_GOODS_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Apparel, Piece Goods, and Notions Merchant Wholesalers',
    },
    { value: GROCERY_WHOLESALERS_INDUSTRY_GROUP, label: 'Grocery and Related Product Merchant Wholesalers ' },
    { value: FARM_PRODUCT_WHOLESALERS_INDUSTRY_GROUP, label: 'Farm Product Raw Material Merchant Wholesalers' },
    {
      value: CHEMICAL_AND_ALLIED_PRODUCTS_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Chemical and Allied Products Merchant Wholesalers',
    },
    { value: PETROLEUM_WHOLESALERS_INDUSTRY_GROUP, label: 'Petroleum and Petroleum Products Merchant Wholesalers ' },
    {
      value: BEER_WINE_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Beer, Wine, and Distilled Alcoholic Beverage Merchant Wholesalers',
    },
    {
      value: MISCELLANEOUS_NONDURABLE_GOODS_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Miscellaneous Nondurable Goods Merchant Wholesalers',
    },
  ],
  [AGENTS_AND_BROKERS_SUB_SECTOR]: [],
  [MOTOR_VEHICLE_AND_PARTS_DEALERS_SUB_SECTOR]: [
    { value: AUTO_DEALERS_INDUSTRY_GROUP, label: 'Automobile Dealers' },
    { value: OTHER_MOTOR_DEALERS_INDUSTRY_GROUP, label: 'Other Motor Vehicle Dealers' },
    { value: AUTOMOTIVE_PARTS_INDUSTRY_GROUP, label: 'Automotive Parts, Accessories, and Tire Retailers' },
  ],
  [BUILDING_MATERIAL_DEALERS_SUB_SECTOR]: [
    { value: BUILDING_MATERIAL_AND_SUPPLIES_DEALERS_INDUSTRY_GROUP, label: 'Building Material and Supplies Dealers' },
    { value: LAWN_AND_GARDEN_EQUIPMENT_INDUSTRY_GROUP, label: 'Lawn and Garden Equipment and Supplies Retailers' },
  ],
  [FOOD_RETAILERS_SUB_SECTOR]: [
    { value: GROCERY_RETAILERS_INDUSTRY_GROUP, label: 'Grocery and Convenience Retailers ' },
    { value: SPECIALTY_FOOD_RETAILERS_INDUSTRY_GROUP, label: 'Specialty Food Retailers' },
    { value: BEER_WINE_LIQUOR_RETAILERS_INDUSTRY_GROUP, label: 'Beer, Wine, and Liquor Retailers' },
  ],
  [FURNITURE_RETAILERS_SUB_SECTOR]: [
    { value: FURNITURE_RETAILERS_INDUSTRY_GROUP, label: 'Furniture and Home Furnishings Retailers' },
    { value: ELECTRONICS_RETAILERS_INDUSTRY_GROUP, label: 'Electronics and Appliance Retailers' },
  ],
  [MERCHANDISE_RETAILERS_SUB_SECTOR]: [
    { value: DEPARTMENT_STORE_INDUSTRY_GROUP, label: 'Department Stores' },
    {
      value: WAREHOUSE_CLUBS_RETAILERS_INDUSTRY_GROUP,
      label: 'Warehouse Clubs, Supercenters, and Other General Merchandise Retailers',
    },
  ],
  [HEALTH_RETAILERS_SUB_SECTOR]: [],
  [GASOLINE_DEALERS_SUB_SECTOR]: [
    { value: GASOLINE_STATIONS_INDUSTRY_GROUP, label: 'Gasoline Stations' },
    { value: FUEL_DEALERS_INDUSTRY_GROUP, label: 'Fuel Dealers' },
  ],
  [CLOTHING_RETAILERS_SUB_SECTOR]: [
    { value: CLOTHING_RETAILERS_INDUSTRY_GROUP, label: 'Clothing and Clothing Accessories Retailers' },
    { value: SHOE_RETAILERS_INDUSTRY_GROUP, label: 'Shoe Retailers' },
    { value: JEWELRY_RETAILERS_INDUSTRY_GROUP, label: 'Jewelry, Luggage, and Leather Goods Retailers' },
  ],
  [SPORTING_GOODS_RETAILERS_SUB_SECTOR]: [
    {
      value: SPORTING_GOODS_RETAILERS_INDUSTRY_GROUP,
      label: 'Sporting Goods, Hobby, and Musical Instrument Retailers',
    },
    { value: BOOK_RETAILERS_INDUSTRY_GROUP, label: 'Book Retailers and News Dealers' },
    { value: FLORISTS_INDUSTRY_GROUP, label: 'Florists ' },
    { value: OFFICE_SUPPLY_RETAILERS_INDUSTRY_GROUP, label: 'Office Supplies, Stationery, and Gift Retailers' },
    { value: USED_MERCHANDISE_INDUSTRY_GROUP, label: 'Used Merchandise Retailers' },
    { value: OTHER_MISCELLANEOUS_INDUSTRY_GROUP, label: 'Other Miscellaneous Retailers' },
  ],
  [AIR_TRANSPORTATION_SUB_SECTOR]: [
    { value: SCHEDULED_AIR_TRANSPORTATION_INDUSTRY_GROUP, label: 'Scheduled Air Transportation' },
    { value: NONSCHEDULED_AIR_TRANSPORTATION_INDUSTRY_GROUP, label: 'Nonscheduled Air Transportation' },
  ],
  [RAIL_TRANSPORTATION_SUB_SECTOR]: [],
  [WATER_TRANSPORTATION_SUB_SECTOR]: [
    { value: DEEP_SEA_TRANSPORTATION_INDUSTRY_GROUP, label: 'Deep Sea, Coastal, and Great Lakes Water Transportation' },
    { value: INLAND_WATER_TRANSPORTATION_INDUSTRY_GROUP, label: 'Inland Water Transportation' },
  ],
  [TRUCK_TRANSPORTATION_SUB_SECTOR]: [
    { value: GENERAL_FREIGHT_TRUCKING_INDUSTRY_GROUP, label: 'General Freight Trucking' },
    { value: SPECIALIZED_FREIGHT_TRUCKING_INDUSTRY_GROUP, label: 'Specialized Freight Trucking' },
  ],
  [TRANSIT_TRANSPORTATION_SUB_SECTOR]: [
    { value: URBAN_TRANSIT_SYSTEMS_INDUSTRY_GROUP, label: 'Urban Transit Systems' },
    { value: INTERURBAN_TRANSPORTATION_INDUSTRY_GROUP, label: 'Interurban and Rural Bus Transportation' },
    { value: TAXI_SERVICE_INDUSTRY_GROUP, label: 'Taxi and Limousine Service' },
    { value: SCHOOL_TRANSPORTATION_INDUSTRY_GROUP, label: 'School and Employee Bus Transportation' },
    { value: CHARTER_BUS_INDUSTRY_GROUP, label: 'Charter Bus Industry' },
    { value: OTHER_TRANSIT_TRANSPORTATION_INDUSTRY_GROUP, label: 'Other Transit and Ground Passenger Transportation' },
  ],
  [PIPELINE_TRANSPORTATION_SUB_SECTOR]: [
    { value: CRUDE_OIL_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP, label: 'Pipeline Transportation of Crude Oil' },
    { value: NATURAL_GAS_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP, label: 'Pipeline Transportation of Natural Gas' },
    { value: OTHER_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP, label: 'Other Pipeline Transportation' },
  ],
  [SCENIC_TRANSPORTATION_SUB_SECTOR]: [
    { value: SCENIC_LAND_INDUSTRY_GROUP, label: 'Scenic and Sightseeing Transportation, Land' },
    { value: SCENIC_WATER_INDUSTRY_GROUP, label: 'Scenic and Sightseeing Transportation, Water' },
    { value: SCENIC_OTHER_INDUSTRY_GROUP, label: 'Scenic and Sightseeing Transportation, Other' },
  ],
  [SUPPORT_ACTIVITIES_FOR_TRANSPORTATION_SUB_SECTOR]: [
    { value: SUPPORT_FOR_AIR_TRANSPORTATION_INDUSTRY_GROUP, label: 'Support Activities for Air Transportation' },
    { value: SUPPORT_FOR_RAIL_TRANSPORTATION_INDUSTRY_GROUP, label: 'Support Activities for Rail Transportation' },
    { value: SUPPORT_FOR_WATER_TRANSPORTATION_INDUSTRY_GROUP, label: 'Support Activities for Water Transportation' },
    { value: SUPPORT_FOR_ROAD_TRANSPORTATION_INDUSTRY_GROUP, label: 'Support Activities for Road Transportation' },
    { value: FREIGHT_TRANSPORTATION_AGREEMENT_INDUSTRY_GROUP, label: 'Freight Transportation Arrangement' },
    { value: OTHER_SUPPORT_TRANSPORTATION_INDUSTRY_GROUP, label: 'Other Support Activities for Transportation' },
  ],
  [POSTAL_SERVICE_SUB_SECTOR]: [],
  [COURIERS_SUB_SECTOR]: [
    { value: COURIER_DELIVERY_INDUSTRY_GROUP, label: 'Couriers and Express Delivery Services' },
    { value: LOCAL_DELIVERY_INDUSTRY_GROUP, label: 'Local Messengers and Local Delivery' },
  ],
  [WAREHOUSING_AND_STORAGE_SUB_SECTOR]: [],
  [MOTION_PIC_INDUSTRIES_SUB_SECTOR]: [
    { value: MOTION_PICTURE_INDUSTRY_GROUP, label: 'Motion Picture and Video Industries' },
    { value: SOUND_INDUSTRY_GROUP, label: 'Sound Recording Industries' },
  ],
  [PUBLISHING_INDUSTRIES_SUB_SECTOR]: [
    { value: NEWSPAPER_INDUSTRY_GROUP, label: 'Newspaper, Periodical, Book, and Directory Publishers' },
    { value: SOFTWARE_PUBLISHERS_INDUSTRY_GROUP, label: 'Software Publishers' },
  ],
  [BROADCASTING_PROVIDER_SUB_SECTOR]: [
    { value: RADIO_AND_TELEVISION_INDUSTRY_GROUP, label: 'Radio and Television Broadcasting Stations' },
    {
      value: MEDIA_STREAMING_INDUSTRY_GROUP,
      label: 'Media Streaming Distribution Services, Social Networks, and Other Media Networks and Content Providers',
    },
  ],
  [TELECOMMUNICATION_SUB_SECTOR]: [
    {
      value: WIRED_TELECOMMUNICATIONS_INDUSTRY_GROUP,
      label: 'Wired and Wireless Telecommunications (except Satellite)',
    },
    { value: SATELLITE_TELECOMMUNICATIONS_INDUSTRY_GROUP, label: 'Satellite Telecommunications' },
    { value: OTHER_TELECOMMUNICATIONS_INDUSTRY_GROUP, label: 'All Other Telecommunications' },
  ],
  [COMPUTING_INFRASTRUCTURE_SUB_SECTOR]: [],
  [WEB_SEARCH_PORTALS_SUB_SECTOR]: [],
  [MONETARY_BANK_SUB_SECTOR]: [],
  [CREDIT_INTERMEDIATION_SUB_SECTOR]: [
    { value: DEPOSITORY_INTERMEDIATION_INDUSTRY_GROUP, label: 'Depository Credit Intermediation' },
    { value: NONDEPOSITORY_INTERMEDIATION_INDUSTRY_GROUP, label: 'Nondepository Credit Intermediation' },
    {
      value: ACTIVITIES_RELATED_TO_CREDIT_INTERMEDIATION_INDUSTRY_GROUP,
      label: 'Activities Related to Credit Intermediation',
    },
  ],
  [SECURITIES_COMMODITY_SUB_SECTOR]: [
    {
      value: COMMODITY_CONTRACTS_INDUSTRY_GROUP,
      label: 'Securities and Commodity Contracts Intermediation and Brokerage',
    },
    { value: COMMODITY_EXCHANGES_INDUSTRY_GROUP, label: 'Securities and Commodity Exchanges' },
    { value: OTHER_FINANCIAL_INVESTMENT_ACTIVITIES_INDUSTRY_GROUP, label: 'Other Financial Investment Activities' },
  ],
  [INSURANCE_CARRIERS_SUB_SECTOR]: [
    { value: INSURANCE_CARRIER_INDUSTRY_GROUP, label: 'Insurance Carriers' },
    {
      value: AGENCIES_BROKERAGES_INDUSTRY_GROUP,
      label: 'Agencies, Brokerages, and Other Insurance Related Activities',
    },
  ],
  [FUNDS_TRUSTS_SUB_SECTOR]: [
    { value: INSURANCE_FUNDS_INDUSTRY_GROUP, label: 'Insurance and Employee Benefit Funds' },
    { value: OTHER_FUNDS_FUNDS_INDUSTRY_GROUP, label: 'Other Investment Pools and Funds' },
  ],
  [REAL_ESTATE_SUB_SECTOR]: [
    { value: LESSORS_OF_REAL_ESTATE_INDUSTRY_GROUP, label: 'Lessors of Real Estate' },
    { value: OFFICES_OF_REAL_ESTATE_INDUSTRY_GROUP, label: 'Offices of Real Estate Agents and Brokers' },
    { value: ACTIVITIES_RELATED_TO_REAL_ESTATE_INDUSTRY_GROUP, label: 'Activities Related to Real Estate' },
  ],
  [RENTAL_AND_LEASING_SUB_SECTOR]: [
    { value: AUTOMOTIVE_LEASING_INDUSTRY_GROUP, label: 'Automotive Equipment Rental and Leasing' },
    { value: CONSUMER_GOODS_RENTAL_INDUSTRY_GROUP, label: 'Consumer Goods Rental' },
    { value: GENERAL_RENTAL_CENTERS_INDUSTRY_GROUP, label: 'General Rental Centers' },
    {
      value: COMMERCIAL_MACHINERY_INDUSTRY_GROUP,
      label: 'Commercial and Industrial Machinery and Equipment Rental and Leasing',
    },
  ],
  [LESSORS_OF_NONFINACIAL_ASSETS_SUB_SECTOR]: [],
  [SCIENTIFIC_SERVICES_SECTOR]: [
    { value: LEGAL_SERVICES_INDUSTRY_GROUP, label: 'Legal Services' },
    {
      value: ACCOUNTING_SERVICES_INDUSTRY_GROUP,
      label: 'Accounting, Tax Preparation, Bookkeeping, and Payroll Services',
    },
    { value: ARCHITECTURAL_SERVICES_INDUSTRY_GROUP, label: 'Architectural, Engineering, and Related Services' },
    { value: DESIGN_SERVICES_INDUSTRY_GROUP, label: 'Specialized Design Services' },
    { value: COMPUTER_SYSTEMS_DESIGN_SERVICES_INDUSTRY_GROUP, label: 'Computer Systems Design and Related Services' },
    {
      value: TECHNICAL_CONSULTING_SERVICES_INDUSTRY_GROUP,
      label: 'Management, Scientific, and Technical Consulting Services',
    },
    { value: SCIENTIFIC_RESEARCH_SERVICES_INDUSTRY_GROUP, label: 'Scientific Research and Development Services' },
    { value: ADVERTISING_SERVICES_INDUSTRY_GROUP, label: 'Advertising, Public Relations, and Related Services' },
    { value: OTHER_TECHNICAL_SERVICES_INDUSTRY_GROUP, label: 'Other Professional, Scientific, and Technical Services' },
  ],
  [ADMINISTRATIVE_SERVICE_SUB_SECTOR]: [
    { value: OFFICE_ADMINISTRATIVE_SERVICES_INDUSTRY_GROUP, label: 'Office Administrative Services' },
    { value: FACILITIES_SUPPORT_SERVICES_INDUSTRY_GROUP, label: 'Facilities Support Services' },
    { value: EMPLOYMENTS_SERVICES_INDUSTRY_GROUP, label: 'Employment Services' },
    { value: BUSINESS_SUPPORT_SERVICES_INDUSTRY_GROUP, label: 'Business Support Services' },
    { value: RESERVATION_SERVICES_INDUSTRY_GROUP, label: 'Travel Arrangement and Reservation Services' },
    { value: INVESTIGATION_AND_SECURITY_SERVICES_INDUSTRY_GROUP, label: 'Investigation and Security Services' },
    { value: SERVICES_TO_BUILDINGS_INDUSTRY_GROUP, label: 'Services to Buildings and Dwellings' },
    { value: OTHER_SUPPORT_SERVICES_INDUSTRY_GROUP, label: 'Other Support Services' },
  ],
  [WASTE_MANAGEMENT_SUB_SECTOR]: [
    { value: WASTE_COLLECTION_INDUSTRY_GROUP, label: 'Waste Collection' },
    { value: WASTE_DISPOSAL_INDUSTRY_GROUP, label: 'Waste Treatment and Disposal' },
    {
      value: REMEDIATION_AND_OTHER_WASTE_MANAGEMENT_SERVICE_INDUSTRY_GROUP,
      label: 'Remediation and Other Waste Management Services',
    },
  ],
  [EDUCATIONAL_SERVICES_SUB_SECTOR]: [
    { value: ELEMENTARY_SCHOOLS_INDUSTRY_GROUP, label: 'Elementary and Secondary Schools' },
    { value: JUNIOR_COLLEGES_INDUSTRY_GROUP, label: 'Junior Colleges' },
    { value: PROFESSIONAL_SCHOOLS_INDUSTRY_GROUP, label: 'Colleges, Universities, and Professional Schools' },
    { value: BUSINESS_SCHOOLS_INDUSTRY_GROUP, label: 'Business Schools and Computer and Management Training' },
    { value: TRADE_SCHOOLS_INDUSTRY_GROUP, label: 'Technical and Trade Schools' },
    { value: OTHER_SCHOOLS_INDUSTRY_GROUP, label: 'Other Schools and Instruction' },
    { value: EDUCATIONAL_SUPPORT_SERVICES_INDUSTRY_GROUP, label: 'Educational Support Services' },
  ],
  [AMBULATORY_CARE_SUB_SECTOR]: [
    { value: PHYSICIANS_INDUSTRY_GROUP, label: 'Offices of Physicians' },
    { value: DENTISTS_INDUSTRY_GROUP, label: 'Offices of Dentists' },
    { value: OTHER_HEALTH_PRACTITIONERS_INDUSTRY_GROUP, label: 'Offices of Other Health Practitioners' },
    { value: OUTPATIENT_CARE_CENTERS_INDUSTRY_GROUP, label: 'Outpatient Care Centers' },
    { value: MEDICAL_LABS_INDUSTRY_GROUP, label: 'Medical and Diagnostic Laboratories' },
    { value: HOME_HEALTH_CARE_SERVICES_INDUSTRY_GROUP, label: 'Home Health Care Services' },
    { value: OTHER_AMBULATORY_HEALTH_CARE_INDUSTRY_GROUP, label: 'Other Ambulatory Health Care Services' },
  ],
  [HOSPITALS_SUB_SECTOR]: [
    { value: GENERAL_MEDICAL_INDUSTRY_GROUP, label: 'General Medical and Surgical Hospitals' },
    { value: SUBSTANCE_ABUSE_HOSPITALS_INDUSTRY_GROUP, label: 'Psychiatric and Substance Abuse Hospitals' },
    {
      value: SPECIALTY_HOSPITALS__INDUSTRY_GROUP,
      label: 'Specialty (except Psychiatric and Substance Abuse) Hospitals',
    },
  ],
  [NURSING_FACILITIES_SUB_SECTOR]: [
    { value: NURSING_CARE_FACILITIES_INDUSTRY_GROUP, label: 'Nursing Care Facilities (Skilled Nursing Facilities)' },
    {
      value: RESIDENTIAL_INTELLECTUAL_INDUSTRY_GROUP,
      label: 'Residential Intellectual and Developmental Disability, Mental Health, and Substance Abuse Facilities',
    },
    {
      value: RETIREMENT_COMMUNITIES_INDUSTRY_GROUP,
      label: 'Continuing Care Retirement Communities and Assisted Living Facilities for the Elderly',
    },
    { value: OTHER_RESIDENTIAL_CARE_INDUSTRY_GROUP, label: 'Other Residential Care Facilities' },
  ],
  [SOCIAL_ASSISTANCE_SUB_SECTOR]: [
    { value: INDIVIDUAL_AND_FAMILY_SERVICES_INDUSTRY_GROUP, label: 'Individual and Family Services' },
    {
      value: OTHER_RELIEF_SERVICES_INDUSTRY_GROUP,
      label: 'Community Food and Housing, and Emergency and Other Relief Services',
    },
    { value: VOCATIONAL_REHABILITATION_SERVICES_INDUSTRY_GROUP, label: 'Vocational Rehabilitation Services' },
    { value: CHILD_CARE_SERVICES_INDUSTRY_GROUP, label: 'Child Care Services' },
  ],
  [PERFORMING_ARTS_SUB_SECTOR]: [
    { value: PERFORMING_ARTS_COMPANIES_INDUSTRY_GROUP, label: 'Performing Arts Companies' },
    { value: SPECTATOR_SPORTS_INDUSTRY_GROUP, label: 'Spectator Sports' },
    {
      value: PROMOTERS_OF_PERFORMING_ARTS_INDUSTRY_GROUP,
      label: 'Promoters of Performing Arts, Sports, and Similar Events',
    },
    {
      value: ARTISTS_AGENTS_AND_MANAGERS_INDUSTRY_GROUP,
      label: 'Agents and Managers for Artists, Athletes, Entertainers, and Other Public Figures',
    },
    { value: INDEPENDENT_ARTISTS_INDUSTRY_GROUP, label: 'Independent Artists, Writers, and Performers' },
  ],
  [MUSEUMS_SUB_SECTOR]: [],
  [AMUSEMENT_INDUSTRY_SUB_SECTOR]: [
    { value: AMUSEMENT_PARKS_INDUSTRY_GROUP, label: 'Amusement Parks and Arcades' },
    { value: GAMBLING_INDUSTRIES_INDUSTRY_GROUP, label: 'Gambling Industries' },
    { value: OTHER_AMUSEMENT_INDUSTRY_GROUP, label: 'Other Amusement and Recreation Industries' },
  ],
  [ACCOMMODATION_SUB_SECTOR]: [
    { value: TRAVELER_ACCOMMODATION_INDUSTRY_GROUP, label: 'Traveler Accommodation' },
    { value: RECREATIONAL_CAMPS_INDUSTRY_GROUP, label: 'RV (Recreational Vehicle) Parks and Recreational Camps' },
    { value: WORKERS_CAMPS_INDUSTRY_GROUP, label: "Rooming and Boarding Houses, Dormitories, and Workers' Camps" },
  ],
  [FOOD_SERVICES_AND_DRINKING_PLACES_SUB_SECTOR]: [
    { value: SPECIAL_FOOD_SERVICES_INDUSTRY_GROUP, label: 'Special Food Services' },
    { value: DRINKING_PLACES_INDUSTRY_GROUP, label: 'Drinking Places (Alcoholic Beverages)' },
    { value: OTHER_EATING_PLACES_INDUSTRY_GROUP, label: 'Restaurants and Other Eating Places' },
  ],
  [REPAIR_AND_MAINTENANCE_SUB_SECTOR]: [
    { value: AUTOMOTIVE_REPAIR_INDUSTRY_GROUP, label: 'Automotive Repair and Maintenance' },
    { value: ELECTRONICS_REPAIR_INDUSTRY_GROUP, label: 'Electronic and Precision Equipment Repair and Maintenance' },
    {
      value: COMMERCIAL_REPAIR_AND_MAINTENANCE_INDUSTRY_GROUP,
      label:
        'Commercial and Industrial Machinery and Equipment (except Automotive and Electronic) Repair and Maintenance',
    },
    { value: PERSONAL_GOODS_REPAIR_INDUSTRY_GROUP, label: 'Personal and Household Goods Repair and Maintenance' },
  ],
  [LAUNDRY_SERVICE_SUB_SECTOR]: [
    { value: PERSONAL_CARE_SERVICES_INDUSTRY_GROUP, label: 'Personal Care Services ' },
    { value: DEATH_CARE_SERVICES_INDUSTRY_GROUP, label: 'Death Care Services ' },
    { value: LAUNDRY_SERVICES_INDUSTRY_GROUP, label: 'Drycleaning and Laundry Services' },
    { value: OTHER_PERSONAL_SERVICES_INDUSTRY_GROUP, label: 'Other Personal Services ' },
  ],
  [RELIGIOUS_SUB_SECTOR]: [
    { value: RELIGIOUS_ORGANIZATIONS_INDUSTRY_GROUP, label: 'Religious Organizations ' },
    { value: GRANTMAKING_INDUSTRY_GROUP, label: 'Grantmaking and Giving Services' },
    { value: SOCIAL_ADVOCACY_INDUSTRY_GROUP, label: 'Social Advocacy Organizations' },
    { value: SOCIAL_ORGANIZATIONS_INDUSTRY_GROUP, label: 'Civic and Social Organizations' },
    {
      value: BUSINESS_LABOR_POLITICAL_INDUSTRY_GROUP,
      label: 'Business, Professional, Labor, Political, and Similar Organizations',
    },
  ],
  [ADMINISTRATION_OF_HOUSING_PROGRAMS_SUB_SECTOR]: [],
  [PRIVATE_HOUSEHOLDS_SUB_SECTOR]: [],
  [EXECUTIVE_LEGISLATIVE_SUB_SECTOR]: [],
  [JUSTICE_PUBLIC_ORDER_SUB_SECTOR]: [],
  [ADMINISTRATION_OF_HUMAN_RESOURCE_SUB_SECTOR]: [],
  [ADMINISTRATION_OF_ENVIRONMENTAL_QUALITY_SUB_SECTOR]: [],
  [ADMINISTRATION_OF_ECONOMIC_PROGRAMS_SUB_SECTOR]: [],
  [SPACE_RESEARCH_SUB_SECTOR]: [],
  [NATIONAL_SECURITY_SUB_SECTOR]: [],
  [MANAGEMENT_OF_COMPANIES_SECTOR]: [],
};
